import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { buttonStyles, type ButtonVariant } from './buttonStyles';
import { Icon, type IconName } from './Icon';

type ButtonLinkProps = {
  to: string;
  children: ReactNode;
  variant?: ButtonVariant;
  icon?: IconName;
  className?: string;
};

const isExternal = (to: string) => /^(https?:|mailto:|tel:|#)/.test(to);

/** Bouton qui mène vers une route interne, une ancre ou un lien externe. */
export function ButtonLink({ to, children, variant = 'encre', icon, className }: ButtonLinkProps) {
  const classes = buttonStyles(variant, className);
  const content = (
    <>
      {icon && <Icon name={icon} size={16} />}
      {children}
    </>
  );

  if (isExternal(to)) {
    return (
      <a href={to} className={classes}>
        {content}
      </a>
    );
  }

  return (
    <Link to={to} className={classes}>
      {content}
    </Link>
  );
}
